export const HeroData = [
    {
        title: 'Hi my,',
        title2:'name is Sachie',
        text: 'I love creating beautiful user experiences.',
        ctext:'hero-text',
        linkText: 'Get in Touch',
        clinkText:'hero-btn',
        linkPath:'/contact-page',
    },

    {
        title3: 'Lets',
        title4: 'Get in Touch',

    },
    {
        title5: 'Welcome to',
        title6: 'my Portfolio',

    },

]